(function () {
  function getCurrentMode() {
    return document.documentElement.getAttribute('data-drogon-theme') || 'dark';
  }

  function updateButtons(mode) {
    var buttons = document.querySelectorAll('[data-drogon-theme-toggle]');

    buttons.forEach(function (button) {
      var isLight = mode === 'light';

      button.setAttribute('aria-pressed', isLight ? 'true' : 'false');
      button.setAttribute('aria-label', isLight ? 'Switch to dark mode' : 'Switch to light mode');
      button.setAttribute('title', isLight ? 'Switch to dark mode' : 'Switch to light mode');
    });
  }

  function setMode(mode) {
    document.documentElement.setAttribute('data-drogon-theme', mode);

    try {
      localStorage.setItem('drogon-theme-mode', mode);
    } catch (error) {}

    updateButtons(mode);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('[data-drogon-theme-toggle]');

    updateButtons(getCurrentMode());

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var currentMode = getCurrentMode();
        var nextMode = currentMode === 'light' ? 'dark' : 'light';

        setMode(nextMode);
      });
    });
  });
})();